/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;

	const setSliderArrowTop = (s) => {
		let img = document.querySelector("." + s +"-item-img img");
		if(img) {
			let btn01 = document.querySelector("." + s +"-control .swiper-button-next");
			let btn02 = document.querySelector("." + s +"-control .swiper-button-prev");

			if(img.height > 0) {
				btn01.style.top = img.height / 2 + "px";
				btn02.style.top = img.height / 2 + "px";
			}
		}
	}

	// 5分でわかる　スライダー
	if(document.querySelectorAll('.company-slider01').length) {
		document.querySelectorAll('.company-slider01').forEach((ele,idx) => {
			let sliderid = 'company-slider01_'+idx;
			ele.setAttribute('id',sliderid);
			sliderid = '#'+sliderid;
			
			const companySwiper = new Swiper(sliderid, {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true,
				slidesPerView: "auto",
				centeredSlides: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.company-slider01-control .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.company-slider01-control .swiper-button-next',
					prevEl: '.company-slider01-control .swiper-button-prev',
				},
				breakpoints: {
					1025: {
						slidesPerView: 4,
						spaceBetween: 20,
						centeredSlides: false,
					},
					769: {
						slidesPerView: 3,
						spaceBetween: 30,
					}
				},
			});
			document.querySelector('.company-slider01-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					companySwiper.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					companySwiper.autoplay.stop();
				}
			});
			setTimeout(() => {
				setSliderArrowTop("company-slider01");
			}, 1500);
		});
	}

	const imgResize = (elm1,elm2,bgHeight,innerHeight) => {
		let img = document.querySelector(elm1);
		if(!img) return;
		let bg = document.querySelector(elm2);
		let ratioY = bg.height / bgHeight;
		img.style.height = innerHeight * ratioY + "px";
	}

	const inViewAnimationCompany = () => {
		const target = document.querySelectorAll('.js-company');
		const options = {
			root: null,
			rootMargin: '-30% 0px',
			threshold: 0
		};
		const callback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					imgResize(".js-company-graph01",".js-company-graph02",644,594);
					imgResize(".js-company-graph03",".js-company-graph04",378,275);
					imgResize(".js-company-graph05",".js-company-graph06",378,245);
					imgResize(".js-company-graph03.__english",".js-company-graph04.__english",367,275);
					imgResize(".js-company-graph05.__english",".js-company-graph06.__english",367,245);

					entry.target.classList.add(v);
				}
			});
		};
		const observer = new IntersectionObserver(callback, options);
		
		const target2 = document.querySelectorAll('.js-company2');
		const options2 = {
			root: null,
			rootMargin: '-50% 0px',
			threshold: 0
		};
		const observer2 = new IntersectionObserver(callback, options2);

		window.addEventListener('resize', () => {
			let resizeTime = 0;
			clearTimeout(resizeTime);
			resizeTime = setTimeout(() => {
				imgResize(".js-company-graph01",".js-company-graph02",644,594);
				imgResize(".js-company-graph03",".js-company-graph04",378,275);
				imgResize(".js-company-graph05",".js-company-graph06",378,245);
				imgResize(".js-company-graph03.__english",".js-company-graph04.__english",367,275);
				imgResize(".js-company-graph05.__english",".js-company-graph06.__english",367,245);
				setSliderArrowTop("company-slider01");
			}, 300);
		});

		target.forEach(ele => {
			observer.observe(ele);
		});

		target2.forEach(ele => {
			observer2.observe(ele);
		});
	}

	// <事業拠点　国内／国外>CSVインポート
	const networkCsvImport = () => {
		let csvFilePath = $path.replace('index.html','') + 'data.csv';
		let imgPath = '/images'+ $path.replace('index.html','').replace('/english', '');
		const $output = document.querySelectorAll('.js-output');
		const $map = document.querySelectorAll('.js-map-list');
		if($output.length) {
			let titleIdx;
			let titleTxt;
			let tradeNameIdx;
			let typeIdx;
			let nameIdx;
			let zipIdx;
			let addressIdx;
			let longitudeIdx;
			let latitudeIdx;
			let telIdx;
			let webIdx;
			let businessIdx;
			let accessIdx1;
			let accessIdx2;
			let imgIdx;
			let pdfFileName;
			let pdfFilePath;
			let dateProtectionOfficer;
			let contact;
			let allHtml = '';
			let btnHtml = '';
			let btnClass = '_01';
			let count = 0;

			const req = new XMLHttpRequest();
			req.open('get', csvFilePath, true);
			req.send(null);
			req.onload = function(){
				let tmp = req.responseText.split('\n');

				tmp.forEach((val, idx) => {
					let data = val.split(',');
					if(data.length) {
						if(idx === 0) {
							data.forEach((ele,idx) => {
								if(ele === '分類' || ele === '国') {
									titleIdx = idx;
								}
								if(ele === '事業所名' || ele === '社名') {
									nameIdx = idx;
								}
								if(ele === '種別') {
									typeIdx = idx;
								}
								if(ele === '商号') {
									tradeNameIdx = idx;
								}
								if(ele === '郵便番号') {
									zipIdx = idx;
								}
								if(ele === '住所') {
									addressIdx = idx;
								}
								if(ele === '緯度') {
									longitudeIdx = idx;
								}
								if(ele === '経度') {
									latitudeIdx = idx;
								}
								if(ele === '電話番号') {
									telIdx = idx;
								}
								if(ele === 'URL') {
									webIdx = idx;
								}
								if(ele === '事業内容') {
									businessIdx = idx;
								}
								if(ele.replace('\r','') === '画像') {
									imgIdx = idx;
								}
								if(ele === '公共交通機関をご利用の場合') {
									accessIdx1 = idx;
								}
								if(ele === 'お車をご利用の場合') {
									accessIdx2 = idx;
								}
								if(ele === 'PDFファイル名') {
									pdfFileName = idx;
								}
								if(ele === 'PDFファイルパス') {
									pdfFilePath = idx;
								}
								if(ele === '個人情報管理責任者') {
									dateProtectionOfficer = idx;
								}
								if(ele === '連絡先') {
									contact = idx;
								}
							});
						} else {
							if(data.length !== 1) {
								if(data[nameIdx] !== '') {
									let titleTxt = data[titleIdx];
									// 分類
									if(titleTxt !== tmp[idx -1].split(',').filter(Boolean)[titleIdx]) {
										count += 1;
										if(allHtml !== '') {
											allHtml += '</section>';	
										}
										allHtml += '<section class="mod-spacer-large">';
										allHtml += '<h2 class="mod-head02" id="section'+ count +'">'+ titleTxt +'</h2>';
										btnClass = '_0' + count;

										// マップへの出力（海外）
										if($path.indexOf('/networkfc/') !== -1) {
											btnHtml += '<li class="company-networkjp-map-list-item _'+ count +'">'
											+ '<a href="#section'+ count +'" rel="scroll" class="__btn">'
											+ '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_bottom_02"></use></svg><span class="__txt">'+ titleTxt +'</span></a></li>';
										}
									}
									// 事業所名
									allHtml += '<div class="mod-spacer-middle"><h3 class="mod-head03" id="'+ idx +'">'+ data[nameIdx] +'</h3>';
									// 種別
									if (data[typeIdx] !== '') {
										allHtml += '<span class="company-networkjp-block-tag mod-tag">'+ data[typeIdx] +'</span>';
									}
									// 画像
									allHtml += '<div class="company-networkjp-block mod-spacer-32_24"><figure class="company-networkjp-block-img"><img src="'+ imgPath + data[imgIdx] +'" alt=""></figure>';
									// テーブル開始
									allHtml += '<div class="company-networkjp-block-conts"><table class="mod-tbl01 va_middle"><tbody>';
									// 商号
									if(tradeNameIdx !== undefined) {
										allHtml += '<tr><th>商号</th><td>'+ data[tradeNameIdx] +'</td></tr>';
									}
									// 住所
									if(zipIdx !== undefined) {
										allHtml += '<tr><th>';
										allHtml += $path.includes('/english/') ? 'Address' : '所在地';
										allHtml += '</th><td><p>'+ data[zipIdx] +'</p>';
									} else {
										allHtml += '<tr><th>';
										allHtml += $path.includes('/english/') ? 'Address' : '所在地';
										allHtml += '</th><td>';
									}
									allHtml += '<p><span class="mr15">'+ data[addressIdx] +'</span>';
									// Googleマップリンク
									if(data[longitudeIdx] !== '') {
										allHtml += '<a href="https://www.google.com/maps/search/?api=1&query='+ data[longitudeIdx] +'%2C'+ data[latitudeIdx] +'" target="_blank" class="mod-link-txt01 di_iblock"><svg aria-hidden="true" class="mr5 _blue"><use xlink:href="/common/svg/sprite.svg#map"></use></svg><span>MAP</span></a>';
									}
									allHtml += '</p></td></tr>';
									// TEL
									if(data[telIdx] !== '') {
										if($path.indexOf('/networkfc/') !== -1) {
											allHtml += '<tr><th>TEL</th><td>+'+ data[telIdx] +'</td></tr>';
										} else {
											allHtml += '<tr><th>TEL</th><td>'+ data[telIdx] +'</td></tr>';
										}
									}
									//　主な事業内容
									allHtml += '<tr><th>';
									allHtml += $path.includes('/english/') ? 'Lines of Business' : '主な事業内容';
									allHtml += '</th><td>'+ data[businessIdx] +'</td></tr>';
									// 個人情報管理責任者・連絡先
									if(data[dateProtectionOfficer] !== undefined && data[dateProtectionOfficer] !== '') {
										allHtml += '<tr><th>';
										allHtml += $path.includes('/english/') ? 'Date protection Officer' : '個人情報管理責任者';
										if(data[dateProtectionOfficer] !== undefined && data[contact] !== '') {
											allHtml += '</th><td>'+ data[dateProtectionOfficer] +' (Contact: <a href="mailto:'+ data[contact] +'" class="mod-link03"><span class="td_under">'+ data[contact] +'</span></a>)</td></tr>';
										} else {
											allHtml += '</th><td>'+ data[dateProtectionOfficer] +'</td></tr>';
										}
										
									}
									// ウェブサイト
									if(data[webIdx] !== '') {
										allHtml += '<tr><th>';
										allHtml += $path.includes('/english/') ? 'Website' : 'ウェブサイト';
										allHtml += '</th><td><a href="'+ data[webIdx] +'" target="_blank" class="mod-link-txt01"><span>'+ data[webIdx] +'</span><svg aria-hidden="true" class="ml5"><use xlink:href="/common/svg/sprite.svg#blank"></use></svg></a></td></tr>';
									}
									// PDF
									if(data[pdfFileName] !== undefined  && data[pdfFileName] !== '') {
										allHtml += '<tr><th>';
										allHtml += $path.includes('/english/') ? 'Additional information' : '備考';
										allHtml += '</th><td><a href="'+ data[pdfFilePath] +'" target="_blank" class="mod-link03"><span>'+ data[pdfFileName] +'</span><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#pdf"></use></svg></a></td></tr>';
									}
									allHtml += '</tbody></table>';
									// アクセス案内詳細
									if(accessIdx1 !== undefined && data[accessIdx1] !== '') {
										allHtml += '<button type="button" class="company-networkjp-block-access-btn mod-spacer-24_20 js-toggle"><span class="__txt">アクセス案内詳細</span><span class="__icon" aria-hidden="true"></span></button><div class="company-networkjp-block-access-block js-toggleBlock">';
										allHtml += '<p class="__head">公共交通機関をご利用の場合</p>';
										allHtml += '<p class="__txt">'+ data[accessIdx1] +'</p>';
										if(data[accessIdx2] !== '') {
											allHtml += '<p class="__head">お車をご利用の場合</p>';
											allHtml += '<p class="__txt">'+ data[accessIdx2] +'</p>';
										}
										allHtml += '</div>';
									}
									allHtml += '</div></div></div>';

									// マップへの出力（国内）
									if($path.indexOf('/networkjp/') !== -1) {
										btnHtml += '<li class="company-networkjp-map-list-item _'+ idx +'">'
										+ '<a href="#'+ idx +'" rel="scroll" class="__btn '+ btnClass +'">'
										+ '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_bottom_02"></use></svg><span class="__txt">'+ data[nameIdx] +'</span></a></li>';
									}
								}
								
							}
						}
					}
				});
				$output[0].innerHTML = allHtml;
				$map[0].innerHTML = btnHtml;

				FUNCTIONS.setImgAttrWidthHeight();
				FUNCTIONS.nextToggle();
				FUNCTIONS.easeScroll();

				setTimeout(() => {
					document.querySelector('.is-o0').classList.remove('is-o0');
				},2000)
			};

		}
	}

	if(document.querySelectorAll('.company-understanding-video-control-button').length) {
		var companyVideo = document.getElementById('company-understanding-video');
		document.querySelector('.company-understanding-video-control-button').addEventListener('click', (e) => {
			if(!(e.currentTarget.classList.contains(a))) {
				e.currentTarget.ariaLabel = '停止';
				e.currentTarget.classList.add(a);
				companyVideo.play();
			} else {
				e.currentTarget.ariaLabel = '再生';
				e.currentTarget.classList.remove(a);
				companyVideo.pause();
			}
		});
	}

	// ==============================================
	const items = document.querySelectorAll( '.js-count' );
 
	const isFloat = ( n ) => {
		return Number( n ) === n && n % 1 !== 0;
	}
	
	const getDecimalPointLength =( n ) => {
		return ( String( n ).split( '.' )[1] || '' ).length;
	}
	
	const observeAction = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
		if ( ! entry.target.classList.contains( 'is-visible' ) ) {
			const isFloat = (entry.target.dataset.isfloat === "true") ? true : false;
			const counterEle = entry.target.querySelector( '.counter .number' );
			const from = Number( entry.target.dataset.from || 0 );
			const to = Number( entry.target.dataset.to || 0 );
			const duration = Math.trunc( entry.target.dataset.duration ) || 1500;
	
			if ( !Number.isFinite( from ) || !Number.isFinite( to ) || from > to ) {
			return false;
			}
	
			const increment = to - from;
			const deciamlPointLength = getDecimalPointLength( increment );
			const startTime = performance.now();
	
			const countUp = ( timestamp ) => {
			const elapsed = performance.now() - startTime;
			const countValue = ( from + ( ( elapsed / duration ) * increment ) ).toFixed( deciamlPointLength );
	
			if ( countValue >= to ) {
				counterEle.innerText = (isFloat) ? entry.target.dataset.to : to.toLocaleString();
			} else {
				counterEle.innerText = Number( countValue ).toLocaleString();
				requestAnimationFrame( countUp );
			}
			}
			
			requestAnimationFrame( countUp );
	
			entry.target.classList.add( 'is-visible' ); 
		}
		}
	} );
	}
	
	const options = {
		threshold: 1,
	}
	
	const obsever = new IntersectionObserver( observeAction, options );
	
	items.forEach( target => {
		obsever.observe( target );
	} );

	// ==============================================
	networkCsvImport();
	inViewAnimationCompany();

})(window.FUNCTIONS);
